const React = require("react");

const useLifeCycleEvent = (props) => {
  const { frmSettings, moduleSettings } = props;
  const {
    onInit: onInitFRM,
    onFinish: onFinishFRM,
    onError: onErrorFRM,
    onTimeout: onTimeoutFRM,
    config: configFRM,
  } = frmSettings || {};
  const {
    onReady,
    onError,
    onCriticalFailure,
    onTimeout: onTimeoutModule,
    config: configModule,
  } = moduleSettings || {};

  const frmTimestamps = React.useRef({
    onInit: 0,
    onFinish: 0,
  });

  const { timeout: timeoutFRM } = configFRM || {};
  const { timeout: timeoutModule } = configModule || {};

  const onInit = ({ moduleInfo }) => {
    frmTimestamps.current = {
      ...frmTimestamps.current,
      onInit: new Date().getTime(),
    };
    onInitFRM?.({ timestamp: frmTimestamps.current.onInit, moduleInfo });
  };

  const onFinish = ({ moduleInfo, error: moduleError }) => {
    frmTimestamps.current = {
      ...frmTimestamps.current,
      onFinish: new Date().getTime(),
    };

    if (moduleError) {
      onErrorFRM?.({
        timestamp: frmTimestamps.current.onFinish,
        moduleInfo,
        error: moduleError,
        timestamps: frmTimestamps.current,
      });
    } else {
      onFinishFRM?.({
        timestamp: frmTimestamps.current.onFinish,
        moduleInfo,
        timestamps: frmTimestamps.current,
      });
    }
  };

  const onTimeout = ({ moduleInfo, payload }) => {
    onTimeoutFRM?.({
      timestamp: new Date().getTime(),
      moduleInfo,
      payload,
      timestamps: frmTimestamps.current,
    });
  };

  const onModuleTimeout = ({ moduleInfo }) => {
    onTimeoutModule?.({
      timestamp: new Date().getTime(),
      moduleInfo,
      timestamps: frmTimestamps.current,
    });
  };

  const onModuleReady = ({ moduleInfo, payload }) => {
    onReady?.({
      timestamp: new Date().getTime(),
      moduleInfo,
      payload,
      timestamps: frmTimestamps.current,
    });
  };

  const onModuleError = ({ moduleInfo, payload, error: moduleError }) => {
    onError?.({
      timestamp: new Date().getTime(),
      moduleInfo,
      payload,
      error: moduleError,
      timestamps: frmTimestamps.current,
    });
  };
  const onModuleFailure = ({ moduleInfo, error: moduleError, payload }) => {
    onCriticalFailure?.({
      timestamp: new Date().getTime(),
      moduleInfo,
      payload,
      error: moduleError,
      timestamps: frmTimestamps.current,
    });
  };

  return {
    onInit,
    onFinish,
    onTimeout,
    onModuleReady,
    onModuleError,
    onModuleFailure,
    onModuleTimeout,
    config: {
      frm: {
        timeout: timeoutFRM,
      },
      module: {
        timeout: timeoutModule,
      },
    },
  };
};

module.exports = useLifeCycleEvent;
